import { Player } from '@lottiefiles/react-lottie-player';
import { BLUE_LOADER } from 'constants/lottie/loading_blue';
import { WHITE_LOADER } from 'constants/lottie/loading_whilte';

interface ButtonLoaderProps {
  isWhiteLoader?: boolean;
}

export const ButtonLoader: React.FC<ButtonLoaderProps> = ({ isWhiteLoader = true }) => {
  return (
    <Player src={JSON.parse(isWhiteLoader ? WHITE_LOADER : BLUE_LOADER)} className='lottie-player' loop autoplay />
  );
};
